import { ThunkType } from "../../../../core/store/reducers";
import { getDailyTradingExcel } from "../api/getDailyTradingExcel";
import fileDownload from "js-file-download";
import { setFetchState } from "../dailyTradeDataSlice";

export const downloadDailyTradingExcel = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.reports.dailyTrade;
  const user = store.data.auth.current.user;
  dispatch(setFetchState({ type: "started" }));
  const dailyTrading = await dispatch(getDailyTradingExcel(user, filter));
  if (dailyTrading) {
    fileDownload(
      new Blob([dailyTrading as any], {
        type: "application/vnd.openxmlformat",
      }),
      "DailyTrading.xlsx"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
